import React, { useState, useEffect } from 'react';
import { Cloud, CloudRain, Sun, Snowflake, Wind, CloudFog } from 'lucide-react';

// Open-Meteo: free, no API key. Tlaxcala capital approx coords.
const LAT = 19.3139;
const LNG = -98.2404;

// WMO weather codes → icon + label
function weatherFromCode(code) {
  if (code === 0) return { icon: Sun, label: 'Soleado', color: '#F59E0B' };
  if (code <= 3) return { icon: Cloud, label: 'Nubes', color: '#94A3B8' };
  if (code <= 49) return { icon: CloudFog, label: 'Niebla', color: '#64748B' };
  if (code <= 69) return { icon: CloudRain, label: 'Lluvia', color: '#3B82F6' };
  if (code <= 79) return { icon: Snowflake, label: 'Nieve', color: '#60A5FA' };
  if (code <= 99) return { icon: Wind, label: 'Tormenta', color: '#7C3AED' };
  return { icon: Cloud, label: '—', color: '#94A3B8' };
}

export default function WeatherWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${LAT}&longitude=${LNG}&current=temperature_2m,weather_code&timezone=America%2FMexico_City`);
        const json = await res.json();
        if (!cancelled) setData(json.current);
      } catch { /* silent */ }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!data) return null;
  const { icon: Icon, label, color } = weatherFromCode(data.weather_code);
  return (
    <div data-testid="weather-widget" className="hidden md:flex items-center gap-1.5 text-[10px] tracking-[0.15em] uppercase font-bold text-white/80">
      <Icon className="h-3 w-3" style={{ color }} />
      <span className="text-white font-black">{Math.round(data.temperature_2m)}°C</span>
      <span className="text-white/40">Tlaxcala · {label}</span>
    </div>
  );
}
